module.exports = __webpack_public_path__ + "img/your-deposit.bd5981d5.svg";